/**
 * Unwrap backend SSE realtime envelopes to the catalog message kiosk already
 * consumes (`type: 'product_update'`, `updateType`, nested `data`).
 *
 * Fail-closed on unsupported eventVersion / checksum mismatch (shared with kiosk).
 */
import { normalizeRealtimeCatalogSseEventData } from 'pi-kiosk-shared';

export function normalizeShopSseEventData(rawData: string): string {
  return normalizeRealtimeCatalogSseEventData(rawData);
}
